module.exports = __webpack_public_path__ + "static/img/pro_tab3.f3c16ca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/advertisement/introduceFour/pro_tab3.jpg
// module id = mKxV
// module chunks = 171